// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hn34","content":"styles_content__2Zuzx"};